import { Component, input } from '@angular/core';
import { ContactModel } from '../../models/contact-details.model';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../containers/section-wrapper-container/section-wrapper-container.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SummaryItemComponent } from '../../../../shared/components/summary-item/summary-item.component';
import { DatePipe } from '@angular/common';
import { CountryNamePipe } from '../../pipes/country-name.pipe';

@Component({
	selector: 'app-contact-card',
	templateUrl: 'contact-card.component.html',
	imports: [
		MatIconModule,
		SectionWrapperComponent,
		TranslocoModule,
		SummaryItemComponent,
		DatePipe,
		CountryNamePipe,
	],
	standalone: true,
})
export class ContactCardComponent<T extends ContactModel> {
	recordData = input<T>();
}
